/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import AccountTitleStore from '../../store/account_title/AccountTitleStore'
import AccountTitleAction from '../../action/account_title'
import AccountTitleEditView from '../../view/pages/account_title/AccountTitleEditView'
import AccountTitleGroupOptionsStore from '../../store/options/AccountTitleGroupOptionsStore'

class AccountTitleEditContainer extends Component {
  static getStores() {
    return [AccountTitleStore, AccountTitleGroupOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      title: AccountTitleStore.getState(),
      group_options: AccountTitleGroupOptionsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    AccountTitleAction.fetchAccountTitleGroups()
    const titleId = this.state.match.params.title_id
    if (titleId) {
      AccountTitleAction.fetchAccountTitle(titleId)
    }
  }

  render() {
    return AccountTitleEditView(this.state)
  }
}

export default withRouter(Container.create(AccountTitleEditContainer, { withProps: true }))
